module.exports = __webpack_public_path__ + "static/img/default_avatar.d663413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default_avatar.png
// module id = rpiH
// module chunks = 0